import React from "react";
import "../theme/theme.css";
import { Grid, Hidden, Box } from "@mui/material";

const GooglePlayButton = ({ className }) => (
    <a href="https://play.google.com/store/apps/details?id=cardz.app" target="_blank" rel="noreferrer" className={className}>
      <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
           alt="Get it on Google Play" height="60" />
    </a>
);

const AppStoreButton = ({ className }) => (
    <a href="https://apps.apple.com" target="_blank" rel="noreferrer" className={className}>
      <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
           alt="Download on the App Store" height="60" />
    </a>
);

function Header() {
  return (
    <Box className="headerContainer">
      <Grid container className="headerContent" alignItems="center">
        <Grid item xs={12} md={5} className="headerContentLeft">
          <Grid container>
            <Grid item className="headerContentLogo" xs={12}>
              <img
                src={require("../assets/img/CardzLogo_White_Large.png")}
                alt="cardz logo"
              />
            </Grid>
            <Grid item className="headerContentTitle" xs={12}>
              <h1>All your retail shop cards directly at hand!</h1>
            </Grid>
            <Grid item className="headerContentTitle" xs={12}>
              <h2>
                No more searching in your overflowing wallet. With the cardz app
                you can finally keep that nice photo of your loved one in your
                wallet again!
              </h2>
            </Grid>
            <Grid item className="headerContentButtonContainer" xs={12}>
              <div>
                <GooglePlayButton
                  theme={"dark"}
                  className={"custom-style"}
                />
              </div>
              <div className="appstoreButton">
                <AppStoreButton
                  theme={"dark"}
                  className={"custom-style"}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Hidden mdDown>
        <Grid item xs={12} sm={9} md={7} className="headerContentRight">
          <img
            src={require("../assets/img/banner.png")}
            alt="phone screenshot"
            className="responsiveImage"
          />
        </Grid>
        </Hidden>
      </Grid>
    </Box>
  );
}

export default Header